export interface AppConfig {
  firebase: {
    apiKey: string;
    authDomain: string;
    databaseURL: string;
    projectId: string;
    appId: string;
  };
  recaptchaSiteKey: string;
  appCheckDebug: boolean;
  stunUrls: string[];
}

const env = import.meta.env;

export const appConfig: AppConfig = {
  firebase: {
    apiKey: env.VITE_FIREBASE_API_KEY ?? '',
    authDomain: env.VITE_FIREBASE_AUTH_DOMAIN ?? '',
    databaseURL: env.VITE_FIREBASE_DATABASE_URL ?? '',
    projectId: env.VITE_FIREBASE_PROJECT_ID ?? '',
    appId: env.VITE_FIREBASE_APP_ID ?? '',
  },
  recaptchaSiteKey: env.VITE_RECAPTCHA_SITE_KEY ?? '',
  appCheckDebug: env.VITE_APPCHECK_DEBUG === 'true',
  stunUrls: (env.VITE_STUN_URLS ?? 'stun:stun.l.google.com:19302')
    .split(',')
    .map((url: string) => url.trim())
    .filter(Boolean),
};

export function configurationProblems(config = appConfig): string[] {
  const problems: string[] = [];
  for (const [key, value] of Object.entries(config.firebase)) {
    if (!value) problems.push(`Missing Firebase ${key}.`);
  }
  if (!config.recaptchaSiteKey) problems.push('Missing App Check reCAPTCHA site key.');
  if (config.stunUrls.some((url) => url.startsWith('turn:') || url.startsWith('turns:'))) {
    problems.push('TURN URLs are not allowed in the zero-cost deployment.');
  }
  return problems;
}
